/* global require */

require("./compilers/auto")
require("./compilers/carousel")
require("./compilers/copy_to_clipboard")
require("./compilers/emit")
require("./compilers/formatting")
require("./compilers/progress_bar")
require("./compilers/tabs")
require("./compilers/toggle")
require("./compilers/plyr")
require("./compilers/signature.js")
require("./compilers/lightgallery.js")
require("./compilers/inline_gallery.js")
require("./lib/unpoly")
require("./lib/utils")
